<template>
  <div class="container">
    <qz-search
      :likeSearch="false"
      :label.sync="label"
      :search.sync="search"
      :searchProps.sync="searchProps"
      @getSearchValue="getSearchValue"
    ></qz-search>
    <qz-list
      ref="qzlist"
      titleProp="wfexname"
      :listData.sync="listData"
      :listProps.sync="listProps"
      :buttonProps="buttonProps"
      @goDetail="goDetail"
    >
      <template #bottom="scoped">
        <div class="qzlist-bottom">
          <div>申请时间：{{ scoped.item.cjsj }}</div>
          <div>
            <span :style="returnColor(scoped.item.iswfmes)">
              {{ returnTkText(scoped.item.iswfmes) }}
            </span>
            <span
              class="qzlist-revoke"
              v-if="returnTkText(scoped.item.iswfmes) === '审核中'"
            >
              <van-icon name="revoke"></van-icon>
              撤销
            </span>
          </div>
        </div>
      </template>
    </qz-list>
  </div>
</template>

<script>
import { returnTkText, returnColor } from "@/utils/exChang";
import { Api } from "@/utils/axios";
export default {
  data() {
    return {
      label: {
        shzt: "全部状态"
      },
      search: { shzt: "", iswfmes: "all" },
      xnxq_list: [],
      iswfmes_list: {
        columns: [
          { text: "未通过", value: "0" },
          { text: "已通过", value: "1" },
          { text: "审核中", value: "2" }
        ],
        defaultIndex: 0
      },
      listData: [],
      searchData: [
        {
          label: "学年学期",
          prop: "xnxq",
          options: this.xnxq_list,
          type: "select",
          required: true
        },
        {
          label: "审核状态",
          prop: "shzt",
          options: this.iswfmes_list,
          type: "select"
        }
      ]
    };
  },
  computed: {
    searchProps: {
      get() {
        return this.searchData;
      },
      set(val) {
        return (this.searchData = val);
      }
    },
    listProps: {
      get() {
        return [
          {
            label: "教室类型",
            prop: "gnqmc",
            type: "col"
          },
          {
            label: "容纳人数",
            prop: "syrs",
            type: "col"
          },
          {
            label: "借用周次",
            prop: "kkzc",
            type: "col"
          },
          {
            label: "借用星期",
            prop: "xq",
            type: "col"
          },
          {
            label: "借用节次",
            prop: "kcsj"
          }
        ];
      }
    },
    buttonProps: {
      get() {
        return [
          { label: "取消", cancel: true },
          { label: "审核", func: this.goDetail }
        ];
      }
    }
  },
  created() {
    sessionStorage.setItem("cardType", 2);
    this.getData();
  },
  methods: {
    returnTkText(val) {
      return returnTkText(val);
    },
    returnColor(val) {
      return returnColor(val);
    },
    goDetail(val) {
      val.type = "pass";
      let arr = [];
      if (val instanceof Array) {
        arr = val;
      } else {
        arr.push(val);
      }
      this.$router.push({
        name: "tkshDetail",
        params: { route_params: JSON.stringify(arr) }
      });
    },
    getData() {
      Api.getXnxq().then(res => {
        let defaultIndex = 0;
        let arr = res.data.map((item, index) => {
          if (item.isdqxq === "1") {
            defaultIndex = index;
            this.label.xnxq = item.xqmc;
            this.search.xnxq = item.xnxq01id;
          }
          return {
            text: item.xqmc,
            value: item.xnxq01id
          };
        });
        this.xnxq_list = { columns: arr, defaultIndex: defaultIndex };
        this.searchProps = [
          {
            label: "学年学期",
            prop: "xnxq",
            options: this.xnxq_list,
            type: "select",
            required: true
          },
          {
            label: "审核状态",
            prop: "shzt",
            options: this.iswfmes_list,
            type: "select"
          }
        ];
        this.query();
      });
    },
    getSearchValue(val1, val2, val3) {
      this.search = val1;
      this.label = val2;
      this.searchProps = val3;
      this.query();
    },
    query() {
      Api.getjyList(this.search).then(res => {
        this.listData = res.date;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  height: calc(~"100vh - 120px");
  overflow: auto;
  .qzlist-bottom {
    padding-top: 11.5px;
    display: flex;
    justify-content: space-between;
    font-family: PingFangSC-Regular;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    font-weight: 400;
    margin-bottom: -2px;
    margin-top: 11.5px;
    border-top: 1px solid #e5e5e5;
    .qzlist-revoke {
      position: relative;
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #7469f8;
      letter-spacing: 0;
      margin-left: 16px;
      font-weight: 400;
      line-height: 20px;
      &::before {
        content: "";
        height: 14px;
        position: absolute;
        border-left: 1px solid #e6e6e6;
        top: 4px;
        left: -9px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/teacher/tksh/pass.vue